// prefers-reduced-motion, plus a switch the tuning panel can flip to preview
// it. Under reduced motion the sky holds still: no drift, no twinkles,
// shooting stars or satellites, and home ↔ play cuts instead of panning.
import { createStore, useStore } from '../../systems/store';

const query = typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

export const motionPreference = createStore({ system: query?.matches ?? false, simulated: false });

query?.addEventListener('change', (e) => motionPreference.set((s) => ({ ...s, system: e.matches })));

export function isReducedMotion(): boolean {
  const s = motionPreference.get();
  return s.system || s.simulated;
}

export function useReducedMotion(): boolean {
  const s = useStore(motionPreference);
  return s.system || s.simulated;
}

export function simulateReducedMotion(on: boolean): void {
  motionPreference.set((s) => ({ ...s, simulated: on }));
}
